const MidnightStylesheet = () => {
  return (
    <head>
      <link rel="stylesheet" href="/css/midnight.css" />
    </head>
  );
};

export default MidnightStylesheet;
